




import { StringProp } from '@/util/prop-decorators';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class FilesView extends Vue {
  @StringProp(true)
  private readonly treeNodeId!: string;
}
